document.addEventListener('DOMContentLoaded', function() {
  var slider = document.querySelector('.announcement-slider');
  if (!slider) return;
  function fixSliderAria() {
    var slides = slider.querySelectorAll('.announcement-slider__slide');
    slides.forEach(function(slide) {
      var isHidden = slide.getAttribute('aria-hidden') === 'true';
      var focusables = slide.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      focusables.forEach(function(el) {
        if (isHidden) { el.setAttribute('tabindex', '-1'); } else { el.removeAttribute('tabindex'); }
      });
    });
  }
  fixSliderAria();
  var observer = new MutationObserver(fixSliderAria);
  observer.observe(slider, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
});
